import React, { useMemo } from 'react'
import { Input, Table } from 'antd';
import { IThreePsCodeItem } from '../../threePsCodes.model';
import styles from './threePsCodeTable.module.css';
import { selectIsEditMode } from '../../store/threePsSelectors';
import { useThreePsCodesStore } from '../../store/threePsCodes.store';
import { IThreePsCodeTableProps } from './threePsCodeTable.types';
import { getThreePsCodeColumns } from './threePsCodeTable.columns';

export const ThreePsCodeTable = (props: IThreePsCodeTableProps) => {
    const { data, onFieldChange, attemptedSave } = props;
    const isEditMode = useThreePsCodesStore(selectIsEditMode);

    const emailDescRefs = React.useRef<Record<string, React.ComponentRef<typeof Input> | null>>({});
    const portalDescRefs = React.useRef<Record<string, React.ComponentRef<typeof Input> | null>>({});

    const columns = useMemo(() => getThreePsCodeColumns({
        isEditMode,
        attemptedSave,
        onFieldChange,
        emailDescRefs,
        portalDescRefs,
    }), [isEditMode, attemptedSave, onFieldChange, emailDescRefs, portalDescRefs]);

    return (
        <Table<IThreePsCodeItem>
            className={styles.threePsCodeTable}
            bordered
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey={(row) => row.threePsDataUid}
            rowClassName={(row, index) => `
                ${index % 2 === 0 ? styles.evenRowStyle : styles.oddRowStyle}
                ${row.isReviewCompleted ? styles.greenStripe : styles.orangeStripe}`
            }
            scroll={{ 
                x: 'max-content',
                y: 'calc(100vh - 300px)',
            }}
        />
    )
}
